import {
  SET_COMPANY_ID,
  SET_IS_ADMIN,
  SET_MOBILE_VIEW,
  GET_COMPANY_INFO_SUCCESS,
  REQUEST_FAILURE,
  UPDATE_COMPANY_INFO_SUCCESS,
  GET_COMPANY_INFO_REQUEST,
  UPDATE_COMPANY_INFO_REQUEST,
  CLEAR_MESSAGE,
  GET_BANNER_DATA_REQUEST,
  GET_BANNER_DATA_SUCCESS,
  SET_NOTICE_HEIGHT,
  SET_ENLIGHTEN_MANAGER_TOKEN,
  GET_SFDC_REQUEST,
  GET_SFDC_SUCCESS,
  GET_SFDC_FAILURE,
  UPDATE_ACCOUNT_MANAGER_SUCCESS,
  UPDATE_ACCOUNT_MANAGER_FAILURE,
  GET_AB_FEATURE_REQUEST,
  GET_AB_FEATURE_SUCCESS,
  GET_AB_FEATURE_FAILURE,
  SET_SHOW_PAGE,
  GET_USER_DETAILS,
  GET_USER_DETAILS_SUCCESS,
  GET_USER_DETAILS_FAILURE,
  GET_IMAGE_BANNER_DATA_REQUEST,
  GET_IMAGE_BANNER_DATA_SUCCESS,
  GET_APPLICATION_NOTIFICATIONS_REQUEST,
  GET_APPLICATION_NOTIFICATIONS_FAILURE,
  GET_APPLICATION_NOTIFICATIONS_SUCCESS,
  READ_APPLICATION_NOTIFICATIONS_REQUEST,
  READ_APPLICATION_NOTIFICATIONS_FAILURE,
  SET_FROM_LEFT_TAB,
  GET_APPLICATION_REQUEST,
  GET_APPLICATION_SUCCESS,
  GET_APPLICATION_FAILURE,
  GET_SOLARGRAF_SESSION_SUCCESS,
  GET_PROJECT_DETAILS_REQUEST,
  GET_PROJECT_DETAILS_SUCCESS,
  GET_PROJECT_DETAILS_FAILURE,
  GET_SITE_DETAILS_REQUEST,
  GET_SITE_DETAILS_SUCCESS,
  GET_SITE_DETAILS_FAILURE,
  GET_SOLARGRAF_POPUP_DETAILS_REQUEST,
  SET_ITK,
  CAN_APPLY_DRS_FOR_CC_REQUEST,
  CAN_APPLY_DRS_FOR_CC_SUCCESS,
  CAN_APPLY_DRS_FOR_CC_FAILURE,
  SET_COUNTRY,
  UPDATE_COMPANY_INFO_FAILURE,
  SET_ENLIGHTEN_VERSION_FOOTER
} from './constants';

let initialState = {
  companyId: null,
  isAdmin: false,
  userId: null,
  message: '',
  messageType: '',
  messageUpdateCompany: '',
  messageUpdateCompanyType: '',
  companyInfo: {},
  company: {},
  masterData: {},
  eligibleForEin: false,
  currentlySending: false,
  notificationRequestSending: false,
  bannerNotice: [],
  belongsToAus: false,
  noticeHeight: 0,
  enlightenManagerToken: '',
  belongsToUs: false,
  belongsToIn: false,
  belongsToMx: false,
  belongsToBe: false,
  belongsToNl: false,
  belongsToFr: false,
  belongsToDe: false,
  belongsToUk: false,
  belongsToEs: false,
  belongsToCh: false,
  belongsToNc: false,
  belongsToNz: false,
  belongsToIt: false,
  belongsToPa: false,
  belongsToCo: false,
  belongsToCr: false,
  belongsToBr: false,
  belongsToPr: false,
  belongsToAw: false,
  sfdcUpdating: false,
  communityInfo: {},
  featureList: [],
  featureListLoading: false,
  showPage: false,
  airbrakeProjectId: 311377,
  airbrakeProjectKey: 'c0b3e2ee6a915c3c179b316427a1d4da',
  licenseTypes: [],
  companyName: '',
  logoUrl: '',
  companyState: '',
  einOptIn: false,
  einOptOut: false,
  installingSince: '',
  sitesCount: '',
  storagesCount: '',
  microinvertersCount: '',
  companyTier: '',
  ensembleTraining: '',
  solarInstallCertification: '',
  imageBanner: [],
  fromLeftPanel: false,
  notificationList: [],
  unseenNotificationCount: '',
  solargrafToken: '',
  projectDetails: {},
  siteDetails: {},
  solargrafPopupDetails: {
    linkWithSolargrafSuccess: '',
    solargrafAccessAction: '',
    startSolargrafPopupFlow: false
  },
  fromITK: false,
  // for drs left panel integration
  isEnphaseUniversityApp: false,
  drsIdForLeftPanel: '',
  enlightenVersion: null,
  // ends
  availableLocales: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPANY_INFO_REQUEST:
      return { ...state, currentlySending: true };
    case GET_AB_FEATURE_REQUEST:
      return { ...state, featureListLoading: true, currentlySending: true };
    case GET_AB_FEATURE_SUCCESS:
      return { ...state, featureList: action.featureList, featureListLoading: false, currentlySending: false };
    case GET_AB_FEATURE_FAILURE:
      return {
        ...state,
        message: action.error,
        messageType: 'error',
        featureListLoading: false,
        currentlySending: false
      };
    case GET_USER_DETAILS:
      return { ...state, currentlySending: true };
    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        countryCode: action.countryCode,
        companyName: action.companyName,
        einOptIn: action.einOptIn,
        einOptOut: action.einOptOut,
        logoUrl: action.logoUrl,
        installingSince: action.installingSince,
        sitesCount: action.sitesCount,
        storagesCount: action.storagesCount,
        microinvertersCount: action.microinvertersCount,
        companyTier: action.companyTier,
        companyState: action.companyState,
        ensembleTraining: action.ensembleTraining,
        solarInstallCertification: action.solarInstallCertification,
        belongsToAus: action.belongsToAus,
        belongsToUs: action.belongsToUs,
        belongsToIn: action.belongsToIn,
        belongsToMx: action.belongsToMx,
        belongsToBe: action.belongsToBe,
        belongsToNl: action.belongsToNl,
        belongsToFr: action.belongsToFr,
        belongsToDe: action.belongsToDe,
        belongsToUk: action.belongsToUk,
        belongsToEs: action.belongsToEs,
        belongsToCh: action.belongsToCh,
        belongsToNc: action.belongsToNc,
        belongsToNz: action.belongsToNz,
        belongsToIt: action.belongsToIt,
        belongsToPa: action.belongsToPa,
        belongsToCo: action.belongsToCo,
        belongsToCr: action.belongsToCr,
        belongsToBr: action.belongsToBr,
        belongsToPr: action.belongsToPr,
        belongsToAw: action.belongsToAw,
        currentlySending: false
      };
    case SET_COUNTRY:
      return {
        ...state,
        belongsToAus: action.belongsToAus,
        belongsToUs: action.belongsToUs,
        belongsToIn: action.belongsToIn,
        belongsToMx: action.belongsToMx,
        belongsToBe: action.belongsToBe,
        belongsToNl: action.belongsToNl,
        belongsToFr: action.belongsToFr,
        belongsToDe: action.belongsToDe,
        belongsToUk: action.belongsToUk,
        belongsToEs: action.belongsToEs,
        belongsToCh: action.belongsToCh,
        belongsToNc: action.belongsToNc,
        belongsToNz: action.belongsToNz,
        belongsToIt: action.belongsToIt,
        belongsToPa: action.belongsToPa,
        belongsToCo: action.belongsToCo,
        belongsToCr: action.belongsToCr,
        belongsToBr: action.belongsToBr,
        belongsToPr: action.belongsToPr,
        belongsToAw: action.belongsToAw
      };
    case GET_USER_DETAILS_FAILURE:
    case CAN_APPLY_DRS_FOR_CC_FAILURE:
      return { ...state, message: action.error, messageType: 'error', currentlySending: false };
    case GET_BANNER_DATA_REQUEST:
      return { ...state };
    case CLEAR_MESSAGE:
      return {
        ...state,
        message: '',
        messageType: ''
      };
    case UPDATE_COMPANY_INFO_REQUEST:
      return { ...state, currentlySending: true, messageUpdateCompany: '', messageTypeUpdateCompany: '' };
    case SET_COMPANY_ID:
      return { ...state, companyId: action.companyId };
    case SET_IS_ADMIN:
      return { ...state, isAdmin: action.isAdmin };
    case SET_MOBILE_VIEW:
      return { ...state, isMobileView: action.isMobileView };
    case SET_SHOW_PAGE:
      return { ...state, showPage: action.showPage };
    case SET_NOTICE_HEIGHT:
      return { ...state, noticeHeight: action.noticeHeight };
    case SET_ENLIGHTEN_MANAGER_TOKEN:
      return { ...state, enlightenManagerToken: action.enlightenManagerToken };
    case GET_COMPANY_INFO_SUCCESS:
      return {
        ...state,
        companyInfo: action.companyInfo,
        company: action.company,
        masterData: action.masterData,
        einUrls: action.einUrls,
        dashboardLinks: action.dashboardLinks,
        message: '',
        messageType: '',
        eligibleForEin: action.eligibleForEin,
        currentlySending: false,
        belongsToAus: action.belongsToAus,
        countryCode: action.countryCode,
        belongsToUs: action.belongsToUs,
        belongsToIn: action.belongsToIn,
        belongsToMx: action.belongsToMx,
        belongsToBe: action.belongsToBe,
        belongsToNl: action.belongsToNl,
        belongsToFr: action.belongsToFr,
        belongsToDe: action.belongsToDe,
        belongsToUk: action.belongsToUk,
        belongsToEs: action.belongsToEs,
        belongsToCh: action.belongsToCh,
        belongsToNc: action.belongsToNc,
        belongsToNz: action.belongsToNz,
        belongsToIt: action.belongsToIt,
        belongsToPa: action.belongsToPa,
        belongsToCo: action.belongsToCo,
        belongsToCr: action.belongsToCr,
        belongsToBr: action.belongsToBr,
        belongsToPr: action.belongsToPr,
        belongsToAw: action.belongsToAw
      };
    case GET_BANNER_DATA_SUCCESS:
      return {
        ...state,
        bannerNotice: action.bannerNotice,
        licenseTypes: action.licenseTypes,
        availableLocales: action.availableLocales,
        message: '',
        messageType: '',
        currentlySending: false
      };
    case UPDATE_COMPANY_INFO_SUCCESS:
      return {
        ...state,
        companyInfo: action.companyInfo,
        company: action.company,
        messageUpdateCompany: action.message,
        messageUpdateCompanyType: 'success',
        eligibleForEin: action.eligibleForEin,
        currentlySending: false,
        belongsToAus: action.belongsToAus,
        countryCode: action.countryCode,
        belongsToUs: action.belongsToUs,
        belongsToIn: action.belongsToIn,
        belongsToMx: action.belongsToMx,
        belongsToBe: action.belongsToBe,
        belongsToNl: action.belongsToNl,
        belongsToFr: action.belongsToFr,
        belongsToDe: action.belongsToDe,
        belongsToUk: action.belongsToUk,
        belongsToEs: action.belongsToEs,
        belongsToCh: action.belongsToCh,
        belongsToNc: action.belongsToNc,
        belongsToNz: action.belongsToNz,
        belongsToIt: action.belongsToIt,
        belongsToPa: action.belongsToPa,
        belongsToCo: action.belongsToCo,
        belongsToCr: action.belongsToCr,
        belongsToBr: action.belongsToBr,
        belongsToPr: action.belongsToPr,
        belongsToAw: action.belongsToAw
      };
    case UPDATE_COMPANY_INFO_FAILURE:
      return {
        ...state,
        currentlySending: false,
        messageUpdateCompany: action.error,
        messageUpdateCompanyType: 'error'
      };
    case GET_SFDC_REQUEST:
      return {
        ...state,
        sfdcUpdating: true
      };
    case GET_SFDC_SUCCESS:
      return {
        ...state,
        communityInfo: action.communityInfo
      };
    case GET_SFDC_FAILURE:
      return {
        ...state,
        sfdcUpdating: false
      };
    case UPDATE_ACCOUNT_MANAGER_FAILURE:
      return {
        ...state,
        sfdcUpdating: false
      };
    case UPDATE_ACCOUNT_MANAGER_SUCCESS:
      return {
        ...state,
        companyInfo: action.companyInfo,
        company: action.company,
        eligibleForEin: action.eligibleForEin,
        belongsToAus: action.belongsToAus,
        belongsToUs: action.belongsToUs,
        countryCode: action.countryCode,
        sfdcUpdating: false,
        belongsToIn: action.belongsToIn,
        belongsToMx: action.belongsToMx,
        belongsToBe: action.belongsToBe,
        belongsToNl: action.belongsToNl,
        belongsToFr: action.belongsToFr,
        belongsToDe: action.belongsToDe,
        belongsToUk: action.belongsToUk,
        belongsToEs: action.belongsToEs,
        belongsToCh: action.belongsToCh,
        belongsToNc: action.belongsToNc,
        belongsToNz: action.belongsToNz,
        belongsToIt: action.belongsToIt,
        belongsToPa: action.belongsToPa,
        belongsToCo: action.belongsToCo,
        belongsToCr: action.belongsToCr,
        belongsToBr: action.belongsToBr,
        belongsToPr: action.belongsToPr,
        belongsToAw: action.belongsToAw
      };
    case GET_IMAGE_BANNER_DATA_REQUEST:
      return { ...state };
    case GET_IMAGE_BANNER_DATA_SUCCESS:
      return { ...state, imageBanner: action.imageBanner, currentlySending: false };
    case REQUEST_FAILURE:
      return {
        ...state,
        message: action.error,
        messageType: 'error',
        currentlySending: false
      };
    case GET_APPLICATION_NOTIFICATIONS_REQUEST:
      return { ...state, notificationRequestSending: true };
    case GET_APPLICATION_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notificationList: action.notificationList,
        notificationRequestSending: false,
        unseenNotificationCount: action.unseenNotificationCount
      };
    case GET_APPLICATION_NOTIFICATIONS_FAILURE:
      return { ...state, message: action.error, messageType: 'error', notificationRequestSending: false };
    case READ_APPLICATION_NOTIFICATIONS_REQUEST:
      return { ...state };
    case READ_APPLICATION_NOTIFICATIONS_FAILURE:
      return { ...state, message: action.error, messageType: 'error' };
    case SET_FROM_LEFT_TAB:
      return { ...state, fromLeftPanel: action.fromLeftPanel };
    case GET_APPLICATION_REQUEST:
      return { ...state, currentlySending: true };
    case GET_APPLICATION_SUCCESS:
      return {
        ...state,
        currentlySending: false
      };
    case GET_APPLICATION_FAILURE:
      return {
        ...state,
        currentlySending: false
      };
    case GET_SOLARGRAF_SESSION_SUCCESS:
      return {
        ...state,
        solargrafToken: action.solargrafToken
      };
    case GET_PROJECT_DETAILS_REQUEST:
      return { ...state, currentlySending: true };
    case GET_PROJECT_DETAILS_SUCCESS:
      return { ...state, currentlySending: false, projectDetails: action.projectDetails };
    case GET_PROJECT_DETAILS_FAILURE:
      return { ...state, currentlySending: false };
    case GET_SITE_DETAILS_REQUEST:
      return { ...state, currentlySending: true };
    case GET_SITE_DETAILS_SUCCESS:
      return { ...state, currentlySending: false, siteDetails: action.siteDetails };
    case GET_SITE_DETAILS_FAILURE:
      return { ...state, currentlySending: false };
    case GET_SOLARGRAF_POPUP_DETAILS_REQUEST:
      return { ...state, solargrafPopupDetails: { ...state.solargrafPopupDetails, ...action.payload } };
    case CAN_APPLY_DRS_FOR_CC_REQUEST:
      return {
        ...state,
        // TODO - FIX ME -> ENLM-13021
        // Hard fix for production release
        // Made 'currentlySending' to false as this is taking too much time to load / timeout occurs
        currentlySending: false
      };
    case CAN_APPLY_DRS_FOR_CC_SUCCESS:
      return {
        ...state,
        isEnphaseUniversityApp: action.canApplyDRSForCC,
        drsIdForLeftPanel: action.drsIdForLeftPanel,
        currentlySending: false
      };
    case SET_ITK:
      return {
        ...state,
        fromITK: action.fromITK
      };
    case SET_ENLIGHTEN_VERSION_FOOTER:
      return {
        ...state,
        enlightenVersion: action.payload
      };
    default:
      return state;
  }
};

export default reducer;
